export default __webpack_public_path__ + "build/e4f25d8491eca31d7a064de6cff10f41.svg";